import {configureStore, Middleware} from '@reduxjs/toolkit';

import createMiddleware from '/redux/middleware/create';
import rootReducer from '/redux/reducer';

import Sanitizers from './sanitizers';

const customMiddleware = createMiddleware() as Middleware[];
const isDev = __DEV__;
const devToolsOptions = isDev
  ? {
      name: 'OptaviaConnect',
      actionSanitizer: Sanitizers.actionSanitizer,
      stateSanitizer: Sanitizers.stateSanitizer,
    }
  : {};
const Reactotron = isDev
  ? require('../../config/reactotron.config').Reactotron
  : undefined;
const store = configureStore({
  reducer: rootReducer,
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware({
      serializableCheck: false,
      immutableCheck: {
        warnAfter: 100,
      },
    }).concat(customMiddleware),
  devTools: devToolsOptions,
  enhancers: getDefaultEnhancers =>
    isDev && Reactotron?.createEnhancer
      ? getDefaultEnhancers().concat(Reactotron.createEnhancer())
      : getDefaultEnhancers(),
});

export default store;
